import AgricultureIcon from "@mui/icons-material/Agriculture";
import PersonIcon from "@mui/icons-material/Person";
import type React from "react";

import { classList } from "~lib/classList.ts";

import styles from "./AutocompleteOption.module.scss";

export interface AutocompleteOptionProps
  extends React.HTMLProps<HTMLLIElement> {
  icon?: React.ReactNode;
  label: string;
  secondary?: React.ReactNode;
  info?: React.ReactNode;
}

export function AutocompleteOption({
  icon,
  label,
  secondary,
  info,
  className,
  ...props
}: AutocompleteOptionProps) {
  return (
    <li {...props} className={classList(styles.option, className && className)}>
      <span className={styles.option__label}>
        {icon && <i>{icon}</i>}
        <span className={styles.option__text}>
          <span>{label}</span>
          {secondary && (
            <span className={styles.option__secondary}>{secondary}</span>
          )}
        </span>
      </span>
      {info && <span className={styles.option__info}>{info}</span>}
    </li>
  );
}

export interface AutocompleteResourceOptionProps
  extends AutocompleteOptionProps {
  employeesCount: number;
  toolsCount: number;
}

export function AutocompleteResourceOption({
  employeesCount,
  toolsCount,
  ...props
}: AutocompleteResourceOptionProps) {
  return (
    <AutocompleteOption
      {...props}
      info={
        <span className={styles.resourceInfo}>
          <span>
            <i>
              <PersonIcon fontSize="small" />
            </i>
            <span>{employeesCount}</span>
          </span>
          <span>
            <i>
              <AgricultureIcon fontSize="small" />
            </i>
            <span>{toolsCount}</span>
          </span>
        </span>
      }
    />
  );
}
